import {AbstractPanel} from '../stats-panel';
import type {RenderingContext} from '../types';
import {patch} from '../utils';

export class ProgramsPanel extends AbstractPanel {
    private static _realUseProgram: RenderingContext['useProgram'];

    private _gl!: RenderingContext;
    private _usedPrograms = 0;

    public constructor(name = 'PS', bg = '#761', fg = '#fda', max = 10, decimals = 0) {
        super(name, bg, fg, max, decimals);
    }

    public get value(): number {
        return this._usedPrograms;
    }

    public get maxValue(): number {
        return 50;
    }

    public update(): void {
        this.reset();
    }

    public reset(): void {
        this._usedPrograms = 0;
    }

    public onInstall(gl?: RenderingContext): void {
        if (!gl) {
            throw Error('Stats: ProgramsPanel > Rendering context must be provided');
        }

        this._gl = gl;

        ProgramsPanel._realUseProgram = this._gl.useProgram;

        gl.useProgram = patch(gl.useProgram, this._fakeUseProgram.bind(this));
    }

    public onUninstall(): void {
        this._gl.useProgram = ProgramsPanel._realUseProgram;
    }

    private _fakeUseProgram(): void {
        this._usedPrograms++;
    }
}